import dayjs from 'dayjs';
import { DATE_TIME } from '@cast/constants';

import { toDateTimePrecise, getTimeAgo } from '@cast/utils';
import { Typography, Box } from '@cast/design-system';

type Props = {
  date?: string;
  preciseFormat?: boolean;
};

const toDateTime = (dateString: string) => {
  return dayjs(dateString).format(DATE_TIME);
};

export const NodeDetailsTime = ({ date, preciseFormat = true }: Props) => {
  const formatter = preciseFormat ? toDateTimePrecise : toDateTime;
  const dateAt = date ? formatter(date) : '-';
  const dateAge = date ? getTimeAgo(date, false) : null;

  return (
    <Box
      maxWidth={200}
      display="flex"
      flexDirection="column"
      alignItems="flex-end"
    >
      <Typography variant="P14R">{dateAt}</Typography>
      {dateAge && (
        <Typography variant="P12R" color="textSecondary">
          {dateAge}
        </Typography>
      )}
    </Box>
  );
};
